import { render, staticRenderFns } from "./ModerateTweet.vue?vue&type=template&id=55240966&scoped=true&"
import script from "./ModerateTweet.vue?vue&type=script&lang=js&"
export * from "./ModerateTweet.vue?vue&type=script&lang=js&"
import style0 from "./ModerateTweet.vue?vue&type=style&index=0&id=55240966&lang=scss&scoped=true&"
import style1 from "./ModerateTweet.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55240966",
  null
  
)

export default component.exports